import { FC } from 'react'
import { Flex } from 'antd'
import MetricRegressionFlag from './MetricRegressionFlag'

interface Props {
  value: string
  showFlag: boolean
  flagHelpText: string
  flagTestId: string
}

const MetricDeltaCell: FC<Props> = ({
  value,
  showFlag,
  flagHelpText,
  flagTestId,
}) => {
  return (
    <Flex align="center" gap="small">
      {value}
      {showFlag ? (
        <MetricRegressionFlag helpText={flagHelpText} testId={flagTestId} />
      ) : null}
    </Flex>
  )
}

export default MetricDeltaCell
